export interface StatusMeta {
    css: string;   // pill colour class
    key: string;   // i18n translation key
}
  
// Packages
export const PACKAGE_STATUS_META: Record<number, StatusMeta> = {
    1 : { css: 'status-new',      key: 'App.Status.new' },
    2 : { css: 'status-received', key: 'App.Status.received' },
    3 : { css: 'status-received', key: 'App.Status.receivedDamaged' },
    5 : { css: 'status-received', key: 'App.Status.picked' },
    6 : { css: 'status-grey',     key: 'App.Status.delivered' },
    7 : { css: 'status-grey',     key: 'App.Status.returned' },
    8 : { css: 'status-refused',  key: 'App.Status.refused' },
    9 : { css: 'status-grey',     key: 'App.Status.removed' },
    11: { css: 'status-grey',     key: 'App.Status.cancelled' },
    13: { css: 'status-received', key: 'App.Status.receivedEmpty' },
    15: { css: 'status-refused',  key: 'App.Status.redirect' },
    16: { css: 'status-new',      key: 'App.Status.expired' },
    100: { css: 'status-new',     key: 'App.Status.rescheduledDelivery' },
};

export const DELIVERY_PAYMENT_STATUS_META: Record<number, StatusMeta> = {
    1 : { css: 'status-new',      key: 'App.Status.pending' },
    2 : { css: 'status-received', key: 'App.Status.paid' },
    4 : { css: 'status-new',      key: 'App.Status.pending' },
    6 : { css: 'status-received', key: 'App.Status.includedInSubscription' },
    7 : { css: 'status-refused', key: 'App.Status.notApplicable' },
};


/// Locations - update to proper statuses
export const LOCATION_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-new',         key: 'App.Status.prospect' },               // Prospect
    2: { css: 'status-new',         key: 'App.Status.courierApproval' },        // Courier Approval
    3: { css: 'status-new',         key: 'App.Status.legalFinance' },           // Legal + Finance
    4: { css: 'status-new',         key: 'App.Status.courierMapping' },         // Courier Mapping
    5: { css: 'status-new',         key: 'App.Status.hardwareSetup' },          // Hardware Setup
    6: { css: 'status-new',         key: 'App.Status.welcomeKit' },             // Welcome Kit
    7: { css: 'status-new',         key: 'App.Status.training' },               // Training
    8: { css: 'status-refused',     key: 'App.Status.compliance' },             // Compliance
    9: { css: 'status-refused',     key: 'App.Status.storeDetailsReview' },     // Store Details Review
    10: { css: 'status-refused',    key: 'App.Status.readyToGoLive' },          // Ready To Go-Live
    11: { css: 'status-received',   key: 'App.Status.active' },                 // Active
    12: { css: 'status-grey',       key: 'App.Status.inactive' },               // Inactive
};
  
// Users
export const USER_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-received', key: 'App.Status.active' },    // Active
    0: { css: 'status-grey',     key: 'App.Status.inactive' },  // Inactive
};

// Shipments
export const SHIPMENT_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-grey',     key: 'App.Status.inProgress' },    // Pending
    2: { css: 'status-received', key: 'App.Status.complete' },      // Complete
    5: { css: 'status-grey',     key: 'App.Status.inProgress' }     // Draft
};

// Knowledge Center resources
export const KNOWLEDGE_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-received', key: 'App.Status.active' },    // Active
    0: { css: 'status-grey',     key: 'App.Status.inactive' },  // Inactive
};

// Customer Subscription Types (for reference/filters, not used as status column anymore)
export const SUBSCRIPTION_TYPE_META: Record<number, StatusMeta> = {
    0: { css: 'status-received', key: 'App.SubscriptionType.PayPerUse' },       // Pay Per Use (green)
    1: { css: 'status-received', key: 'App.SubscriptionType.IndividualMonth' }, // Individual Monthly (green)
};

// Customer Subscription Status (string-based - from Stripe/CustomerSubscriptionStatusEnum)
export const SUBSCRIPTION_STATUS_META: Record<string, StatusMeta> = {
    'active':             { css: 'status-received', key: 'App.SubscriptionStatus.Active' },
    'canceled':           { css: 'status-grey',     key: 'App.SubscriptionStatus.Canceled' },
};

// Customer Account Status (from AccountStatusEnum)
export const ACCOUNT_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-received', key: 'App.AccountStatus.Activated' },  // Activated (green)
    3: { css: 'status-grey',     key: 'App.AccountStatus.Disabled' },   // Disabled (grey)
};

export const LEAD_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-new',         key: 'App.Status.new' },         // green
    2: { css: 'status-refused',     key: 'App.Status.contacted' },   // blue
    3: { css: 'status-received',    key: 'App.Status.won' },         // green
    4: { css: 'status-grey',        key: 'App.Status.lost' },        // grey
};

export const BUSINESS_TYPE_META: Record<number, StatusMeta> = {
    1: { css: 'status-grey',    key: 'App.BusinessType.ConvenienceStore' },
    2: { css: 'status-grey',    key: 'App.BusinessType.Pharmacy' },
    3: { css: 'status-grey',    key: 'App.BusinessType.LocalShop' },
    4: { css: 'status-grey',    key: 'App.BusinessType.GasStation' },
    5: { css: 'status-grey',    key: 'App.BusinessType.Other' },
};

export const CAPACITY_RANGE_META: Record<number, StatusMeta> = {
    1: { css: 'status-grey',        key: 'App.CapacityRange.P15_and_below' },
    2: { css: 'status-new',         key: 'App.CapacityRange.P16_to_30' },
    3: { css: 'status-refused',     key: 'App.CapacityRange.P31_to_50' },
    4: { css: 'status-received',    key: 'App.CapacityRange.P51_and_above' },
};

export const WEEKLY_OPEN_HOUR_META: Record<number, StatusMeta> = {
    1: { css: 'status-grey',        key: 'App.WeeklyOpenHour.H39_and_below' },
    2: { css: 'status-new',         key: 'App.WeeklyOpenHour.H40_to_60' },
    3: { css: 'status-received',    key: 'App.WeeklyOpenHour.H61_and_above' },
};

export const CUSTOMER_DROPOFF_STATUS_META: Record<number, StatusMeta> = {
    1: { css: 'status-grey',        key: 'App.Status.received' },
    2: { css: 'status-received',    key: 'App.Status.picked' },
};

// Helper to turn map into options for filters / selects (number-keyed)
export const statusOptions = (meta: Record<number, StatusMeta>) => 
    Object.entries(meta).map(([id, m]) => ({ id: +id, value: m.key }));

// Helper for string-keyed status metas (e.g., SUBSCRIPTION_STATUS_META)
export const statusOptionsString = (meta: Record<string, StatusMeta>) =>
    Object.entries(meta).map(([id, m]) => ({ id, value: m.key }));  